import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import Billing from './Billing';
import SimpleOverview from './SimpleOverview';
import Subaccounts from './Subaccounts';
import Settings from './Settings';

export const Dashboard = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem('access_token');
      
      if (!token) {
        window.location.href = '/login';
        return;
      }

      const response = await fetch('/auth/profile', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const userData = await response.json();
        setUserInfo(userData);
        
        // Redirect to payment setup only if subscription is pending payment
        const subscriptionStatus = userData.subscription?.status;
        if (subscriptionStatus === 'pending_payment') {
          navigate('/setup-payment');
          return;
        }
      } else if (response.status === 401) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      } else {
        console.error('Failed to fetch user profile, status:', response.status);
        // Continue without user info to allow navigation
      }
    } catch (err) {
      console.error('Failed to fetch user profile:', err);
      // Continue without user info to allow navigation
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-xl">Loading...</div>
          <div className="text-sm text-gray-500 mt-2">Fetching user profile...</div>
        </div>
      </div>
    );
  }

  return (
    <DashboardLayout userInfo={userInfo} onLogout={logout}>
      <Routes>
        <Route index element={<SimpleOverview userInfo={userInfo} />} />
        <Route path="subaccounts" element={<Subaccounts userInfo={userInfo} />} />
        <Route path="settings" element={<Settings userInfo={userInfo} />} />
        <Route path="billing" element={<Billing />} />
      </Routes>
    </DashboardLayout>
  );
};